import { DashboardScreen } from '@/features/dashboard/dashboard-screen';

export function DashboardPage() {
  return <DashboardScreen />;
}
